import React, { Component } from "react";
import { Switch, Popover, Spin, message } from "antd";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { connect } from "react-redux";
import Render from "../../../components/Renderer";
//import context from '../../../utils/language'
import {
  getListSettingBelt,
  deleteBelt,
  updateStatusDisplatBelt
} from "../../../redux/actions/setting";
import { isReadOnly } from "../../../utils/permission";
import { getBelt } from "../../../redux/actions/dropdown";
import CustomTable from "../../../components/CustomTable";

class Belt extends Component {
  state = {
    form: {},
    data: [],
    visible: {},
    isLoading: false
  };

  componentDidMount() {
    setTimeout(() => {
      this.getList();
    }, 500);
  }

  getList = (param, isFreez) => {
    if (isFreez) this.setState({ isLoading: true });
    else this.setState({ data: [], isLoading: true });
    this.props.getListSettingBelt(param).then(res => {
      this.setState({ isLoading: false });
      if (res && res.payload.status === 200 && res.type.endsWith("SUCCESS")) {
        const data = res.payload.data.data;
        data.sort((a, b) => {
          if (a.airportId === b.airportId) {
            return b.terminalId - a.terminalId;
          }
          return a.airportId > b.airportId ? 1 : -1;
        });
        let array = [],
          distince = {},
          index = 0;
        for (let d of data) {
          // let count = data.filter(
          //   x => x.terminalId === d.terminalId && x.airportId === d.airportId
          // ).length;
          // let span = 1;
          // if (count > 1) {
          //   const countExist = array.filter(
          //     x => x.terminalId === d.terminalId && x.airportId === d.airportId
          //   ).length;
          //   span = countExist === 0 ? count : 0;
          // }
          if (distince[d.airportId] === undefined) {
            distince[d.airportId] = true;
            array.push({
              no: "",
              key: index + data.length + 1,
              isHeader: true,
              airportId: d.airportId,
              airportName: d.airportName
            });
          }
          array.push({
            key: index + 1,
            no: index + 1,
            airportId: d.airportId,
            beltId: d.beltId,
            terminalName: d.terminalName,
            terminalId: d.terminalId,
            beltEn: d.beltNameEn,
            beltTh: d.beltNameTh,
            //rowSpan: span,
            code: d.beltCode,
            display: d.statusDisplay === 1,
            updateDate: d.updateDate,
            remark: d.remark,
            flightScope: d.flightScope
          });
          ++index;
        }
        this.setState({ data: array });
      }
    });
  };

  search = isFreez => {
    let { form } = this.state;
    let param = "";
    if (form.airportID) param = "airportId=" + form.airportID;
    this.getList(param, isFreez);
  };

  onChange = ({ name, value }) => {
    let { form } = this.state;
    form[name] = value;
    this.setState({ form, data: [] }, this.search);
  };

  edit = item => this.props.onEdit(this.props.name, item);
  add = params => this.props.onAdd(this.props.name, params);

  onDelete = item => {
    let { visible } = this.state;
    visible[item.key] = false;
    this.setState({ visible, data: [] });
    this.props.deleteBelt(item.beltId).then(res => {
      if (res.status === 400) {
        message.error("ไม่สามารถลบข้อมูลได้");
      } else if (
        res &&
        res.payload.status === 200 &&
        res.type.endsWith("SUCCESS")
      ) {
        message.success("Delete Belt success");
        this.props.getBelt();
      }
      this.search(true);
    });
  };

  refresh = () => {
    this.props.onRefreshDone();
    setTimeout(() => {
      this.search(true);
    }, 200);
  };

  onCheckChange = (item, checked) => {
    const body = {
      beltId: item.beltId,
      statusDisplay: checked ? 1 : 0
    };
    this.props.updateStatusDisplatBelt(body).then(res => {
      if (res.status === 400) {
        message.error("ไม่สามารถแก้ไขข้อมูลได้");
      } else if (
        res &&
        res.payload.status === 200 &&
        res.type.endsWith("SUCCESS")
      ) {
        message.success("Update status success");
        this.props.getBelt();
        this.search(true);
      }
    });
  };

  renderEmpty = () => ({ props: { colSpan: 0 } });

  renderText = (text, row, index) => {
    if (row.isHeader) {
      return { props: { colSpan: 0 } };
    }
    return <span className="ml-2">{text}</span>;
  };

  renderHeader = (text, row, index) => {
    const readOnly = isReadOnly("beltsetting");
    if (row.isHeader) {
      return {
        children: (
          <div className="d-flex justify-content-between">
            <span className="mr-2 font-weight-bold">{row.airportName}</span>
            {!readOnly && (
              <button
                type="button"
                onClick={() => this.add({ airportId: row.airportId })}
                className="btn btn-sm btn-primary"
              >
                <FontAwesomeIcon icon="plus" /> Add Belt
              </button>
            )}
          </div>
        ),
        props: {
          colSpan: 10,
          style: { background: "#f1f1fd" }
        }
      };
    }
    return text;
  };

  visibleChange = item => {
    let { visible } = this.state;
    visible[item.key] = false;
    this.setState({ visible });
  };

  render() {
    const { form, data, isLoading } = this.state;
    const { refresh } = this.props;
    if (refresh) this.refresh();
    //const { language } = this.props
    const readOnly = isReadOnly("beltsetting");
    //const name = context[language].viewStatModal
    const columns = [
      {
        title: "#",
        key: "no",
        dataIndex: "no",
        width: 50,
        render: this.renderHeader
      },
      {
        title: "Terminal",
        key: "terminal",
        align: "center",
        width: 150,
        render: (value, row, index) => {
          const obj = {
            children: value.terminalName,
            props: {}
          };
          if (value.rowSpan !== undefined) obj.props.rowSpan = value.rowSpan;
          if (value.isHeader) obj.props.colSpan = 0;
          return obj;
        }
      },
      {
        title: "Belt (ENG)",
        dataIndex: "beltEn",
        key: "beltEn",
        align: "center",
        width: 150,
        render: this.renderText
      },
      {
        title: "Belt (TH)",
        dataIndex: "beltTh",
        key: "beltTh",
        width: 150,
        render: this.renderText
      },
      {
        title: "Code",
        dataIndex: "code",
        key: "code",
        width: 150,
        render: this.renderText
      },
      {
        title: "Flight scope",
        dataIndex: "flightScope",
        key: "flightScope",
        width: 150,
        render: (text, row, index) => {
          if (row.isHeader) {
            return { props: { colSpan: 0 } };
          }
          return <span style={{textTransform: 'capitalize'}} className="ml-2">{text}</span>;
        }
      },
      {
        title: "Display (On/Off)",
        key: "display",
        width: 150,
        render: item =>
          item.isHeader ? (
            this.renderEmpty()
          ) : (
            <Switch
              disabled={readOnly}
              onChange={checked => this.onCheckChange(item, checked)}
              checked={item.display}
            />
          )
      },
      {
        title: "Update Date",
        dataIndex: "updateDate",
        key: "updateDate",
        width: 180,
        render: this.renderText
      },
      {
        title: "Edit",
        key: "edit",
        width: 80,
        render: item =>
          item.isHeader ? (
            this.renderEmpty()
          ) : (
            <button
              disabled={readOnly}
              onClick={() => this.edit(item)}
              type="button"
              className="btn btn-outline-success btn-sm"
            >
              <FontAwesomeIcon icon="pen" />
            </button>
          )
      },
      {
        title: "Delete",
        key: "delete",
        width: 80,
        render: item =>
          item.isHeader ? (
            this.renderEmpty()
          ) : readOnly ? (
            <button
              disabled
              type="button"
              className="btn btn-outline-danger btn-sm"
            >
              <FontAwesomeIcon icon="trash" />
            </button>
          ) : (
            <Popover
              visible={this.state.visible[item.key]}
              onVisibleChange={_visible => {
                let { visible } = this.state;
                visible[item.key] = _visible;
                this.setState({ visible });
              }}
              content={
                <div className="col">
                  <button
                    type="button"
                    className="btn btn-outline-danger btn-sm mr-2"
                    onClick={() => this.onDelete(item)}
                  >
                    Delete
                  </button>

                  <button
                    type="button"
                    className="btn btn-outline-secondary btn-sm"
                    onClick={() => this.visibleChange(item)}
                  >
                    Cancel
                  </button>
                </div>
              }
              title="Are you sure?"
              trigger="click"
            >
              <button
                disabled={readOnly}
                onClick={this.delete}
                type="button"
                className="btn btn-outline-danger btn-sm"
              >
                <FontAwesomeIcon icon="trash" />
              </button>
            </Popover>
          )
      }
    ];
    const sum = columns.reduce((a, b) => a + b.width, 0);
    const table = (
      <CustomTable
        pagination={false}
        bordered
        className="tbody-center bg-white"
        columns={columns}
        footer={
          isLoading
            ? () => (
                <div className="text-center">
                  <Spin className="pr-2" />
                  loading...
                </div>
              )
            : null
        }
        // scroll={{ x: sum + "px", y: "60vh" }}
        dataSource={data}
      />
    );

    const template = [
      {
        type: "select",
        name: "airportID",
        label: "Airports",
        value: form.airportID,
        placeholder: "Select Airport...",
        options: {
          name: "airportDOAOptions",
          id: "airportID",
          text: "airportName",
          preFilter: q => q.statusDisplay === 1
        }
      }
    ];
    return (
      <div className="card card-body card-body-component">
        <div className="form-row form-inline col-md-12 mb-3 px-0">
          <div className="col-md-3">
            {!readOnly && (
              <button
                type="button"
                onClick={this.props.onNew}
                className="btn btn-success"
              >
                <FontAwesomeIcon icon="plus" /> Add Belt
              </button>
            )}
          </div>
          <div className="col-md-9 form-inline justify-content-end px-0">
            {template.map((t, i) => (
              <div className="col-md-3 justify-content-end pr-0" key={i}>
                {Render(t, this.onChange)}
              </div>
            ))}
            <button
              onClick={() => this.setState({ form: {} }, this.search)}
              className="btn btn-sm btn-dark ml-2"
            >
              <FontAwesomeIcon icon="redo" />
              <span className="ml-2">clear</span>
            </button>
          </div>
        </div>
        {table}
      </div>
    );
  }
}

const mapStateToProps = state => ({
  language: state.language
});

const mapDispatchToProps = dispatch => ({
  getListSettingBelt: param => dispatch(getListSettingBelt(param)),
  deleteBelt: id => dispatch(deleteBelt(id)),
  getBelt: () => dispatch(getBelt()),
  updateStatusDisplatBelt: body => dispatch(updateStatusDisplatBelt(body))
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Belt);
